import { EPlatformPermissions, ERestrictedSearchPermissions } from '../entities/IPermissions';

export type PermissionLike = string | { name?: string };

export const toPermissionName = (permission: PermissionLike | undefined): string =>
    typeof permission === 'string' ? permission : (permission?.name ?? '');

export const isPlatformAdmin = (permissions: { [key: string]: boolean }) => {
    return permissions?.[EPlatformPermissions.PlatformManagementView];
};

export const canViewProfilePermissions = (permissions: { [key: string]: boolean } | undefined): boolean =>
    !!permissions?.[ERestrictedSearchPermissions.ProfilePermissionsView];

export const findPermmision = (permissions: PermissionLike[] | undefined, elem: string): boolean =>
    (permissions ?? []).some(permission => toPermissionName(permission) === elem);

export const hasPermissionFromSources = (
    permission: string,
    ...sources: unknown[]
): boolean =>
    sources.some(source => {
        if (!source) {
            return false;
        }
        if (Array.isArray(source)) {
            return findPermmision(source as PermissionLike[], permission);
        }
        if (typeof source === 'object') {
            return !!(source as { [key: string]: boolean | undefined })[permission];
        }
        return false;
    });
